"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var PREFIX = 'FileInput';
var classes = {
    avatarWrapper: "".concat(PREFIX, "-avatarWrapper"),
    avatar: "".concat(PREFIX, "-avatar"),
    titleLabel: "".concat(PREFIX, "-titleLabel"),
    uploadLabel: "".concat(PREFIX, "-uploadLabel"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.avatarWrapper)] = {
            width: theme.spacing(20),
            '& input': {
                display: 'none',
            },
        },
        _b[".".concat(classes.avatar)] = {
            width: theme.spacing(10),
            height: theme.spacing(10),
            marginBottom: theme.spacing(4),
        },
        _b[".".concat(classes.titleLabel)] = {
            color: theme.palette.grey[600],
        },
        _b[".".concat(classes.uploadLabel)] = {
            margin: 0,
            cursor: 'pointer',
        },
        _b);
});
var FileInput = function (_a) {
    var _b = _a.input, onChange = _b.onChange, value = _b.value, restFormInputProps = __rest(_b, ["onChange", "value"]), _c = _a.defaultImage, defaultImage = _c === void 0 ? end2end_1.IS_RECHARGLY ? '/company-placeholder_v2.svg' : '/company-placeholder.svg' : _c, label = _a.label, rest = __rest(_a, ["input", "defaultImage", "label"]);
    return ((0, jsx_runtime_1.jsxs)(StyledBox, __assign({ mt: 3 }, { children: [label && (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: label })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ className: classes.avatarWrapper, pt: 4 }, { children: [(0, jsx_runtime_1.jsx)("img", { className: classes.avatar, src: (value === null || value === void 0 ? void 0 : value[0]) ? URL.createObjectURL(value[0]) : defaultImage, alt: "Preview" }), (0, jsx_runtime_1.jsx)(Button_1.default, { children: (0, jsx_runtime_1.jsxs)("label", __assign({ className: classes.uploadLabel }, { children: ["Upload image", (0, jsx_runtime_1.jsx)("input", __assign({}, restFormInputProps, rest, { type: "file", onChange: function (e) {
                                        if (e.target.files && /image\//.test(e.target.files[0].type))
                                            onChange(e.target.files);
                                    }, accept: "image/*" }))] })) })] }))] })));
};
exports.default = FileInput;
